/* eslint-env browser, jquery */
/* global metricsLib */
import 'babel-polyfill';
import page from 'page';
import { handleQueryString as contactForm } from 'auth0-contact-form';
import localeRedirectionMiddleware from 'modules/locale-redirection';
import ab from 'modules/ab-testing';
import metrics from 'modules/metrics';
import { ie } from 'modules/npm-component/user-agent';
import bus from 'modules/npm-component/bus';
import triggers from 'modules/triggers';
import 'bootstrap';
import abVariants from 'pages/ab-variants';
import 'modules/canonical';
import 'modules/boot/sso';
import 'modules/header';
import homepage from 'pages/homepage';
import opensource from 'pages/opensource';
import dashboard from 'pages/dashboard';
import whyAuth0 from 'pages/why-auth0';
import pricing from 'pages/pricing';
import about from 'pages/about';
import customers from 'pages/customers';
import availabilityTrust from 'pages/availability-trust';
import terms from 'pages/terms';
import mcc from 'pages/mcc';
import privacy from 'pages/privacy';
import lock from 'pages/lock';
import authCatalogIndex from 'pages/auth-catalog-index';
import authCatalog from 'pages/auth-catalog';
import changelog from 'pages/changelog';
import wordpress from 'pages/wordpress';
import blog from 'pages/blog';
import docs from 'pages/docs';
import press from 'pages/press';
import eventsLanding from 'pages/events-landing';
import jobs from 'pages/jobs';
import security from 'pages/security';
import whitehat from 'pages/whitehat';
import partners from 'pages/partners';
import passwordless from 'pages/passwordless';
import enterprise from 'pages/enterprise';
import guestAuthors from 'pages/guest-authors';
import breachedPasswords from 'pages/breached-passwords';
import guardian from 'pages/guardian';
import identityGlossary from 'pages/identity-glossary';
import b2c from 'pages/b2c';
import b2b from 'pages/b2b';
import subscriptionCenter from 'pages/subscription-center';
import ambassadorProgram from 'pages/ambassador-program';
import signup from 'pages/signup';
import jp from 'pages/jp';
import resources from 'pages/resources';
import notfound from 'pages/notfound';

const config = window.APP_CONFIG;
// Important note: if you add new components for pages they should list before blog
const pages = [
  homepage,
  opensource,
  dashboard,
  whyAuth0,
  pricing,
  about,
  customers,
  availabilityTrust,
  terms,
  mcc,
  privacy,
  lock,
  authCatalogIndex,
  authCatalog,
  changelog,
  wordpress,
  blog,
  docs,
  press,
  eventsLanding,
  jobs,
  security,
  whitehat,
  partners,
  passwordless,
  enterprise,
  guestAuthors,
  breachedPasswords,
  guardian,
  identityGlossary,
  b2c,
  b2b,
  subscriptionCenter,
  ambassadorProgram,
  signup,
  jp,
  resources
];

/**
 * Boot components
 * and pages.
 */

page(localeRedirectionMiddleware());

if (!config.disable_analytics) {
  page(ab.computeExperiments());
  // - AB testing variants should go here
  abVariants();
}

// init pages
pages.forEach(pageItem => pageItem());

page((ctx, next) => {
  const $ = window.$;
  // FIXME: this should be better handled in future iterations
  if (ctx.notFound) {
    next();
    return;
  }

  ctx.notFound = !!$('.notfound-page').length;
  next();
});

page((ctx, next) => {
  const metricsLib = window.metricsLib;
  if (ctx.querystring.indexOf('signup=true') > -1) {
    window.signup();
  }

  // Contact form
  const contactFormOptions = {
    onModalOpen() {},
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
    }
  };
  contactForm(contactFormOptions, { includePhoneField: true });

  return next();
});

page((ctx, next) => {
  const $ = window.$;
  if (window.location.hostname.toLowerCase() === 'auth0.com') {
    return next();
  }

  $('a[href^="https://auth0.com"]').each(function replaceHref() {
    this.href = this.href.replace('https://auth0.com', '');
  });

  return next();
});

page(ab.executeExperiments());

// no page.js scripts should be
// added after `notfound`

notfound();

const scrollExceptionPages = [
  '/press/news',
  '/press/announcements',
  '/pricing',
  '/jobs',
  '/customers'
];

// Initialize global events binded to page actions
bus.on('page:change', () => {
  const $ = window.$;
  const pathname = window.location.pathname;

  if (scrollExceptionPages.some(exception => pathname.indexOf(exception) !== -1)) return;
  $('body').scrollTop(0);
});

bus.on('page:render', () => {
  triggers.triggerNotSignedUp();
  metrics.onPageRenderEvent();
});

/**
 * Boot page.js
 */
const oldMsie = ie().lte(9);
page({
  click: !oldMsie
});



// WEBPACK FOOTER //
// ./src/client.js